window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  // window.Popper = require('popper.js').default;
  global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');

  // require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Add a response interceptor
axios.interceptors.response.use(function(response) {
  // Do something with response data
  return response
}, function(error) {
  // Do something with response error
  const statusCode = error.response.status
  let title = ''
  let group = ''
  let text = 'Please refresh the page and if the error persists please contact support'
  let duration = -1 // forever

  if (statusCode >= 500) {
    title = '<h1>SERVER ERROR</h1>'
  }

  if (statusCode >= 400 && statusCode < 500) {
    title = '<h4>Application error</h4>'
  }

  if (statusCode === 401) {
    title = '<h4>Unauthorized</h4>'
    text = 'You are unauthorized to make that request'
  }
  if (statusCode === 422) {
    title = '<h5>Validation Error</h5>'
    const failedFields = []
    if (error.response && error.response.data) {
      if (error.response.data.errors) {
        Object.keys(error.response.data.errors).forEach((field) => {
          failedFields.push(error.response.data.errors[field][0])
        })
        text = failedFields.join('<br>')
      }

      if (error.response.data.notificationGroup) {
        group = error.response.data.notificationGroup
      }
    }

    duration = 6000
  }

  // app.$notify({
  //   title: title,
  //   type: 'error',
  //   text: text,
  //   duration: duration,
  //   group: group,
  // })

  return Promise.reject(error)
})
